var runtime = require("../../../../../../../wix-vod-widget/build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"mainUiBlock":"_1MT4f","tooltipContainerWrapper":"_2sS3v"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._1MT4f{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column}"+wrap+" ._1MT4f ._2sS3v{position:relative;flex-grow:2}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

runtime.addInitialStyle(module.exports);